import styled, { css } from 'styled-components';
import { STAR_RATING, STAR_RATING_FILLED, STAR_RATING_EMPTY_STATE, RatingTypesTemplate } from '../constants/RatingTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const backgroundPillStyles = css(["width:", "px;background-color:", ";border:2px solid ", ";border-radius:", ";"], ({
  disabled
}) => disabled ? 20 : 30, ({
  checked,
  disabled,
  theme: _theme
}) => {
  const theme = _theme;
  if (checked) {
    return theme.color['icon-tertiary-default'];
  } else if (disabled) {
    return theme.color['border-core-subtle'];
  }
  return theme.color['icon-core-on-fill-default'];
}, ({
  checked,
  theme: _theme
}) => {
  const theme = _theme;
  return checked ? theme.color['icon-tertiary-default'] : theme.color['border-core-subtle'];
}, ({
  index
}) => {
  if (index === 1) {
    return '8px 0 0 8px';
  } else if (index === 5) {
    return '0 8px 8px 0';
  }
  return 0;
});
const foregroundPillStyles = css(["background-color:", ";width:", ";"], ({
  theme: _theme
}) => {
  const theme = _theme;
  return theme.color['icon-tertiary-default'];
}, ({
  percentFilled,
  disabled
}) => percentFilled && `${percentFilled * (disabled ? 20 : 30) / 100}px`);
export const PillIcon = styled.div.withConfig({
  displayName: "AbstractRatingIcons__PillIcon",
  componentId: "sc-17wpjea-0"
})(["height:", "px;margin:1px;border-radius:", ";", ";"], ({
  disabled
}) => disabled ? 8 : 15, ({
  index,
  percentFilled
}) => {
  let borderRadius = '0';
  if (index === 1) {
    borderRadius = '8px 0 0 8px';
  } else if (index === 5) {
    borderRadius = '0 8px 8px 0';
  }
  return percentFilled && !(percentFilled < 100 && index === 5) && borderRadius;
}, ({
  isForeground
}) => isForeground ? foregroundPillStyles : backgroundPillStyles);
export const starRatingFactory = type => ({
  checked,
  size,
  isForeground
}) => {
  const color = RatingTypesTemplate[type][`${isForeground || checked ? 'checkedColor' : 'uncheckedColor'}`];
  const Icon = RatingTypesTemplate[type][`${isForeground ? 'checkedIcon' : 'uncheckedIcon'}`];
  return /*#__PURE__*/_jsx(Icon, {
    color: color,
    size: size
  });
};
export const StarRating = starRatingFactory(STAR_RATING);
export const StarRatingFilled = starRatingFactory(STAR_RATING_FILLED);
export const StarRatingEmpty = starRatingFactory(STAR_RATING_EMPTY_STATE);